import { render, staticRenderFns } from "./Link-first-company-exists.vue?vue&type=template&id=32054082&scoped=true&"
import script from "./Link-first-company-exists.vue?vue&type=script&lang=js&"
export * from "./Link-first-company-exists.vue?vue&type=script&lang=js&"
import style0 from "./Link-first-company-exists.vue?vue&type=style&index=0&id=32054082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32054082",
  null
  
)

export default component.exports